import { useEffect, useState } from 'react'
import { api, ApiError } from '../api'
import type { Env, Installer, User } from '../api'

const PLATFORM_LABEL: Record<Installer['platform'], string> = {
  windows: 'Windows',
  macos: 'macOS',
  outro: 'Outro',
}

export function Login({ env, onLogged }: { env: Env | null; onLogged: (u: User, via: 'online' | 'offline') => void }) {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const [installers, setInstallers] = useState<Installer[]>([])
  const online = env?.mode === 'hub'

  useEffect(() => {
    void api.me().then((u) => onLogged(u, 'online')).catch(() => undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (online) void api.installers().then(setInstallers)
  }, [online])

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    try {
      const { user, via } = await api.login(login, password)
      onLogged(user, via)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'falha de conexão')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div style={{ flex: 1, display: 'grid', gridTemplateColumns: '1fr 460px', height: '100%' }}>
      <div className="media-surface" style={{ position: 'relative', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: 48 }}>
        {env?.clinic && (
          <div style={{ font: "500 11px/1 var(--font-mono)", letterSpacing: '.14em', color: '#5d6f79', textTransform: 'uppercase' }}>
            {env.clinic}
          </div>
        )}
        <div style={{ marginTop: 14, font: '600 30px/1.2 var(--font-sans)', color: '#dbe6ec', maxWidth: 520 }}>
          Documentação de exames endoscópicos com captura em tempo real
        </div>
      </div>

      <form onSubmit={submit} style={{ background: 'var(--surface)', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 56px', gap: 22 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 30, height: 30, borderRadius: 7, background: 'var(--primary)', color: 'var(--primary-fg)', display: 'flex', alignItems: 'center', justifyContent: 'center', font: '700 14px/1 var(--font-mono)' }}>C</div>
          <div style={{ font: '600 19px/1 var(--font-sans)', letterSpacing: '-.01em' }}>
            CScan <span style={{ color: 'var(--text-3)', fontWeight: 400 }}>Gastro</span>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <label className="field">
            <span>Usuário</span>
            <input className="input" autoFocus value={login} onChange={(e) => setLogin(e.target.value)} style={{ height: 36 }} />
          </label>
          <label className="field">
            <span>Senha</span>
            <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ height: 36 }} />
          </label>
        </div>

        {error && (
          <div style={{ padding: '9px 11px', border: '1px solid var(--danger)', borderRadius: 6, background: 'var(--danger-soft)', font: '400 12px/1.5 var(--font-sans)', color: 'var(--danger)' }}>
            {error}
          </div>
        )}

        <button className="btn btn-primary" type="submit" disabled={busy} style={{ height: 40, fontSize: 14 }}>
          {busy ? 'Entrando…' : 'Entrar'}
        </button>

        {online && installers.length > 0 && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {installers.map((i) => (
              <a key={i.name} className="btn" href={i.url} download
                style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}>
                Baixar para {PLATFORM_LABEL[i.platform]}
              </a>
            ))}
          </div>
        )}

        <div style={{ font: '400 11px/1 var(--font-mono)', color: 'var(--text-3)' }}>
          CScan Gastro 8.0.0
        </div>
      </form>
    </div>
  )
}
